// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string().primaryKey(),
  orgId: __t.string().name("org_id"),
  sourceId: __t.string().name("source_id"),
  workerId: __t.string().name("worker_id"),
  op: __t.string(),
  root: __t.string(),
  path: __t.string(),
  status: __t.string(),
  result: __t.string(),
  error: __t.string(),
  createdAt: __t.timestamp().name("created_at"),
});
